"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _index = _interopRequireDefault(require("./index.style"));
var _TextField = _interopRequireDefault(require("../../TextField"));
var _calendar = _interopRequireDefault(require("../../../assets/svg/calendar"));
var _Mobile = _interopRequireDefault(require("../Mobile"));
var _Modal = _interopRequireDefault(require("../../FullScreenModal/Modal"));
var _hooks = _interopRequireDefault(require("../../FullScreenModal/hooks"));
var _theme = _interopRequireDefault(require("../../../theme"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InputsDate = props => {
  const {
    dividerInputIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    resetDatesButtonLabel = 'Reset',
    incomingStartDate = '2021-03-01',
    incomingEndDate = '2021/03/25',
    minAvailableDate = '2021/01/29',
    maxAvailableDate = '2021/04/25',
    submitDatesButtonLabel = 'Done',
    datepickerIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    datepickerEndIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    labelStartDate = 'Departure date',
    labelEndDate = 'Return date',
    cancelButtonLabel = 'Cancel',
    startDate = new Date(),
    endDate = new Date(),
    onDateChange = () => {},
    resetCalendar = () => {}
  } = props;
  const btnOpenModal = (0, _react.useRef)(null);
  const classes = (0, _index.default)();
  const isXl = (0, _useMediaQuery.default)(_theme.default.breakpoints.up('xl'));
  const {
    modalProps,
    open: openModal,
    close: closeModal
  } = (0, _hooks.default)({
    background: '#FFF'
  });
  const handleOpenModal = () => {
    openModal(btnOpenModal);
  };
  const handleCloseModal = () => {
    closeModal();
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    ref: btnOpenModal,
    spacing: isXl ? 4 : 3,
    alignItems: "flex-end",
    "aria-controls": "menu-list-grow",
    "aria-haspopup": "true",
    onClick: handleOpenModal
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: classes.gridItem
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    name: "startDateMobile",
    "data-testid": "startDateMobile",
    label: labelStartDate,
    placeholder: placeholderStartDate,
    value: startDate && (0, _dayjs.default)(startDate).format('ddd, MMM DD'),
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, datepickerIcon),
      readOnly: true
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: classes.gridItem
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    name: "endDateMobile",
    label: labelEndDate,
    placeholder: placeholderEndDate,
    value: endDate && (0, _dayjs.default)(endDate).format('ddd, MMM DD'),
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, datepickerEndIcon),
      readOnly: true
    }
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({}, modalProps, {
    padding: false,
    closeButton: false
  }), /*#__PURE__*/_react.default.createElement(_Mobile.default, {
    datepickerIcon: datepickerIcon,
    dividerInputIcon: dividerInputIcon,
    resetDatesButtonLabel: resetDatesButtonLabel,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    minAvailableDate: minAvailableDate,
    maxAvailableDate: maxAvailableDate,
    startDate: startDate,
    endDate: endDate,
    submitDatesButtonLabel: submitDatesButtonLabel,
    placeholderStartDate: placeholderStartDate,
    placeholderEndDate: placeholderEndDate,
    handleCloseModal: handleCloseModal,
    cancelButtonLabel: cancelButtonLabel,
    onDateChange: onDateChange,
    resetCalendar: resetCalendar
  })));
};
var _default = exports.default = InputsDate;